import * as React from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { LoadingIndicator } from '../LoadingIndicator';
import { FaQuestionCircle, FaCreditCard, FaLock } from 'react-icons/fa'
import ReactTooltip from 'react-tooltip'
import SumUpLogo from '../Assets/sumup_logo.png'
import VisaLogo from '../Assets/Visa_2014_logo_detail.svg.png'
import MastercardLogo from '../Assets/320px-Mastercard_2019_logo.svg.png'
import CBLogo from '../Assets/320px-Logo_GIE-CB.jpeg'
import axios from '../services/index'
import './BuyTraining.css';

//This component show the card data form and manage the different call to our API and sumup API
export const BuyTraining: React.FunctionComponent = (props) => {

    let year = new Date().getFullYear();
    const [payload, setPayload] = React.useState({})
    const trainingId = window.location.href.toString().split('/')[5]
    const currentToken = localStorage.getItem('access_token')
    const [submitted, setSubmitted] = React.useState(false)
    const [checkoutId, setCheckoutId] = React.useState('')
    let history = useHistory()
    let location: any = useLocation()

    //Security to disable buying process
    React.useEffect(()=>{
        history.push('/')
    },[])

    //This useEffect is fire at the end of handleSubmit, and call backend in order to create the checkout in SumUp API
    React.useEffect(() => {
        if(submitted) {
            axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/payment/${trainingId}`, {
                headers: {
                    "Authorization": `Bearer ${currentToken}`
                }
            })
            .then(function(response) {
                console.log(response)
                setCheckoutId(response.data.checkout_id)
            })
            .catch(function(error){
                alert("Le paiement a échoué du fait d'une erreur de nos serveurs ! Veuillez réessayer plus tard.")
            })
        }
    },[submitted])

    //This useEffect is trigger at the end of previous useEffect, use the data sent from the back to send card data to the appropriate checkout
    //It also manage the 3D Secure post request if required by creating an html form and post it to the adequate URL
    React.useEffect(() => {
        if(submitted) {
            axios.put(`https://api.sumup.com/v0.1/checkouts/${checkoutId}`, payload )
            .then(function(response) {
                axios.post('https://LaurenceBrun.eu.pythonanywhere.com/logSumUp/', {value: response.data}, 
                {
                    headers: {
                        "Authorization": `Bearer ${currentToken}`
                    }
                }).catch((error)=>{
                    //do nothing
                })
                if (response.status === 202) {
                    var form = document.createElement("form");
                    form.setAttribute("method", "POST");
                    form.setAttribute("action", response.data.next_step.url)
                    for(const property in response.data.next_step.payload) {
                        let attribute = document.createElement("input")
                        attribute.setAttribute('type', 'hidden')
                        attribute.setAttribute('name', property)
                        attribute.setAttribute('value', response.data.next_step.payload[property])
                        form.appendChild(attribute)
                    }
                    document.body.appendChild(form);
                    form.submit()
                }
                if (response.status === 200) {
                    history.push(`/training/${trainingId}/buySuccess?checkout_id=${checkoutId}/`)
                }
            })
            .catch(function(error) {
                setSubmitted(false)
                alert(`Une erreur est survenue ! En voici le motif : ${error.data.message}`)
            })
        }
    },[checkoutId])


    const handleSubmit = (e: any) => {
        e.preventDefault()
        if(e.target.username.value && e.target.ccNumber.value && e.target.month.value && e.target.year.value && e.target.cvv.value) {
            setPayload(
                {
                    "payment_type": "card",
                    "card": {
                        "name": e.target.username.value,
                        "number": e.target.ccNumber.value,
                        "expiry_month": e.target.month.value,
                        "expiry_year": (e.target.year.value-2000).toString(),
                        "cvv": e.target.cvv.value
                    }
                }
            )
            localStorage.setItem('nameLastname', e.target.username.value) 
            setSubmitted(true)
        }
        else {
            alert("Vous devez remplir tous les champs !")
        }
    }

    //Display loader during processing of requests
    const isLoading = () => {
        if (submitted) {
            return(
                <div className="Loading">
                    <div className="Loader"><LoadingIndicator /></div>
                </div>
            )
        }
    }
    
    return(
        <>
        <div className="ConnectBuy">
            {isLoading()}
            <h2>{location.state.name}</h2>
            <h3>Montant : {location.state.price}€</h3>
            <div>
                <img className="MastercardLogo" src={CBLogo} alt="cb logo"></img>
                <img className="VisaLogo" src={VisaLogo} alt="visa logo"></img>
                <img className="MastercardLogo" src={MastercardLogo} alt="mastercard logo"></img>
            </div>
            <form onSubmit={handleSubmit}>
                <label>
                    <input type="text" name="username" placeholder="Nom et Prénom" />
                </label><br />
                <label>
                    <input style={{marginLeft: '20px'}} type="tel" inputMode="numeric" pattern="[0-9\s]{13,19}" maxLength={19} name="ccNumber" placeholder="xxxx xxxx xxxx xxxx" /><FaCreditCard className="TdIcon" size={20} data-tip data-for="CB"/>
                </label><br />
                <label> <span style={{marginLeft: '10px'}} className="asPlaceholder">Date de validité : </span>
                    <select id="month" name="month">
                        <option selected>01</option>
                        <option>02</option>
                        <option>03</option>
                        <option>04</option>
                        <option>05</option>
                        <option>06</option>
                        <option>07</option>
                        <option>08</option>
                        <option>09</option>
                        <option>10</option>
                        <option>11</option>
                        <option>12</option>
                    </select>
                </label>
                <label>
                    <select id="year" name="year">
                        <option selected>{year}</option>
                        <option>{year+1}</option>
                        <option>{year+2}</option>
                        <option>{year+3}</option>
                        <option>{year+4}</option>
                        <option>{year+5}</option>
                        <option>{year+6}</option>
                        <option>{year+7}</option>
                        <option>{year+8}</option>
                        <option>{year+9}</option>
                        <option>{year+10}</option>
                    </select>
                </label><br />
                <label>
                    <input style={{marginLeft: '20px'}} type="password" name="cvv" placeholder="CVV" />
                </label><FaQuestionCircle className="TdIcon" size={20} data-tip data-for="CVV"/><br />
                <input type="submit" value="Payer" className="ConnectButton Connexion" />
            </form>
            <p style={{fontSize: 10}}><FaLock className="TdIconUnclick" size={10}/> Paiement sécurisé avec SumUp <img className="HeaderLogo" src={SumUpLogo} style={{height: "20px", width: "20px", verticalAlign: "middle"}} alt="logo"></img></p>
            <ReactTooltip place="right" type="info" id="CB" >Saisissez les chiffres de votre carte bancaire.</ReactTooltip>
            <ReactTooltip place="right" type="info" id="CVV" >Saisissez les 3 chiffres au dos de votre carte.</ReactTooltip>
        </div>
        <p style={{textAlign:"center", fontSize: "20px"}}>Vous souhaitez utiliser un autre moyen de paiement ? Vous rencontrez une difficulté avec le paiement par carte ? Contactez moi en cliquant <a href="https://en-deuil-et.com/index.php?contact">ici</a>.</p>
        </>
    )
}